import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { logTermAction } from './useTermsOfUseLogs';

interface DiscardTermParams {
  termId: string;
  userId: string;
  userName: string;
}

export const useDiscardTerm = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ termId, userId, userName }: DiscardTermParams) => {
      // Arquiva o termo pendente definindo updated_at e removendo de pendentes
      const { error } = await supabase
        .from('terms_of_use')
        .update({ 
          updated_at: new Date().toISOString(),
          pending_activation: false 
        })
        .eq('id', termId)
        .eq('pending_activation', true);
      
      if (error) throw error;
      
      // Registrar log de descarte
      await logTermAction({
        termId,
        action: 'discard',
        userId,
        userName
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['terms-of-use'] });
      toast.success('Termo descartado com sucesso');
    },
    onError: (error) => {
      console.error('Erro ao descartar termo:', error);
      toast.error('Erro ao descartar o termo');
    }
  });
};
